import useTranslation from 'hooks/useTranslation';

const TextMessage = ({
  id,
  content,
  time,
  replyId,
  locale,
  getMessagePreviewById,
  edited,
  name,
}) => {
  const { getTranslation } = useTranslation('ARCHIVE');
  const { t } = getTranslation();

  // const handleShowRepliedMessage = () => {
  //   // handleScrollIntoView(replyId);
  // };

  return (
    <div
      // data-tool-tip-bottom={time}
      data-id={id}
      className='conv__body__body__inner__msgright__inner__bubble flex flex-ai-e flex-jc-sb'
    >
      <div className='conv__body__body__inner__msgright__inner__bubble__text'>
        {replyId && (
          <div
            dir='auto'
            className='conv__body__body__inner__msgright__inner__bubble__replied_msg'
            // onClick={handleShowRepliedMessage}
          >
            <span>{getMessagePreviewById(replyId)}</span>
          </div>
        )}
        <div dir='auto'>{content}</div>

        <div className='conv__body__body__inner__msgright__inner__bubble__text__info w-100 flex flex-ai-c flex-jc-sb'>
          <div className='conv__body__body__inner__msgright__inner__bubble__text__info__time'>
            {time?.[locale]} {'  '} {edited ? t('EDITED_MESSAGE_BADGE') : ''}{' '}
            {name}
            {'  '} {}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextMessage;
